import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'neutral';
  className?: string;
  'aria-label'?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  variant = 'primary',
  className = '',
  'aria-label': ariaLabel = 'Loading',
}) => {
  const sizeStyles = {
    sm: 'h-4 w-4 border-2',
    md: 'h-6 w-6 border-2',
    lg: 'h-8 w-8 border-3',
  };

  const variantStyles = {
    primary: 'border-primary-600 border-t-transparent',
    neutral: 'border-neutral-600 border-t-transparent',
  };

  return (
    <div role="status" aria-live="polite" aria-label={ariaLabel} className="inline-block">
      <div
        className={`
          rounded-full animate-spin
          ${sizeStyles[size]}
          ${variantStyles[variant]}
          motion-reduce:animate-none motion-reduce:border-t-current
          ${className}
        `}
      />
      <span className="sr-only">{ariaLabel}</span>
    </div>
  );
};
